import { Route, Switch } from "react-router"

import { Home } from '../pages/Home/Home';
import { SendingDocuments } from 'pages/SendingDocuments/SendingDocuments';
import { Profile } from 'pages/Profile/Profile';
import { PersonalProfile } from 'pages/PersonalProfile/PersonalProfile';
import { ProProfile } from 'pages/ProProfile/ProProfile';
import { WebProfile } from 'pages/WebProfile/WebProfile';
import { TermsOfUse } from 'pages/TermsOfUse/TermsOfUse';
import { Support } from 'pages/Support/Support';
import { FAQ } from 'pages/FAQ/FAQ';
import { Agenda } from 'pages/Agenda/Agenda';
import { Gains } from 'pages/Gains/Gains';
import { WhoWeAre } from "pages/WhoWeAre/WhoWeAre";

import { Login } from 'pages/Login/Login';
import { Register } from 'pages/Register/Register';
import { SplashScreen } from 'pages/SplashScreen/SplashScreen';
import { HomeDemo } from 'pages/HomeDemo/HomeDemo';
import { ForgotPassword } from 'pages/ForgotPassword/ForgotPassword';
import { PrivateRoute } from "./PrivateRoute";
import { HowItWorks } from "pages/HowItWorks/HowItWorks";
import { Historic } from "pages/Historic/Historic";
import { Services } from "pages/Services/Services";
import { ResetPassword } from "pages/ResetPassword/ResetPassword";

const Router = () => (
  <Switch>
    <PrivateRoute component={Home} path="/" exact />
    <PrivateRoute component={SendingDocuments} path="/enviar-documentos" exact />
    <PrivateRoute component={Profile} path="/perfil" exact />
    <PrivateRoute component={PersonalProfile} path="/perfil-pessoal" exact />
    <PrivateRoute component={ProProfile} path="/perfil-profissional" exact />
    <PrivateRoute component={WebProfile} path="/perfil-web" exact />
    <PrivateRoute component={TermsOfUse} path="/termos-de-uso" exact />
    <PrivateRoute component={Support} path="/suporte" exact />
    <PrivateRoute component={FAQ} path="/suporte/FAQ" exact />
    <PrivateRoute component={Agenda} path="/agenda" exact />
    <PrivateRoute component={Gains} path="/ganhos" exact />
    <PrivateRoute component={WhoWeAre} path="/quem-somos" exact/>
    <PrivateRoute component={HowItWorks} path="/como-funciona" exact/>
    <PrivateRoute component={Historic} path="/historico" exact/>
    <PrivateRoute component={Services} path="/servicos" exact/>

    <Route component={SplashScreen} path="/" exact />
    <Route component={Login} path="/login" exact />
    <Route component={Register} path="/cadastro" exact />
    <Route component={HomeDemo} path="/demonstracao" exact />
    <Route component={ForgotPassword} path="/alterar-senha" exact />
    <Route component={ResetPassword} path="/resetar-senha" exact />
  </Switch>
)

export default Router;
